import { defineComponent, nextTick } from "vue";
import UploadBox from "../../components/UploadBox";
import OrderLayout from "../../layouts/OrderLayout";
import Tracking from "../../utils/Tracking";
import Utils from "../../utils/Utils";

export default defineComponent({
    components: {
        UploadBox,
        OrderLayout,
    },

    template: `
        <OrderLayout class="StepUpload" :options="options" :step="1" :summarycollapsed="false" @offer:change="$emit('back')" title="Zaczynamy!">
            <div class="StepUpload__box">
                <h2>Wgraj fakturę za prąd</h2>
                <p>
                    Odczytamy dane z faktury rozliczeniowej od Twojego obecnego dostawcy prądu, a następnie przygotujemy wszystkie niezbędne dokumenty.
                </p>

                <UploadBox
                    :options="options"

                    :visible_back="true"

                    @back="$emit('back')"
                    @next="$emit('next')"
                />
            </div>

            <div v-if="!options.documents?.length" class="StepUpload__noinvoice contentbox contentbox--white">
                <div>
                    <h2>Wpisz dane ręcznie</h2>
                    <p>Wpisz dane ręcznie przy użyciu formularza.</p>
                </div>

                <button type="button" class="button button--secondary" @click="onClickNoInvoice">Dalej</button>
            </div>
        </OrderLayout>
    `,

    emits: [
        'next',
        'noinvoice',
        'back',
    ],

    props: {
        /** @var OfferJson */
        options: { type: Object, required: true },
    },

    mounted() {
        nextTick(() => {
            Utils.scrollToEl($('.StepUpload'));
        });
    },

    methods: {
        async onClickNoInvoice() {
            await Tracking.doEvent('click_withoutinvoice_form');

            this.$emit('noinvoice');
        },
    },
});
